// src/components/Surface.js
// Tonal surface system — the "no border lines" rule.
// Sections define their boundaries through background color shifts, never 1px lines.
import styled from 'styled-components';

const surfaceColors = {
  base: '#fff8f5',              // surface
  raised: '#f6ece6',            // surface-container
  inset: '#fcf2ed',             // surface-container-low
  high: '#f1e6e0',              // surface-container-high
  highest: '#ece0d9',           // surface-container-highest
  accent: '#ffac9b',            // primary-container (warm terracotta tint)
  teal: '#84f5e8',              // secondary-container
};

const Surface = styled.div`
  background-color: ${({ tone = 'base' }) => surfaceColors[tone] || surfaceColors.base};
`;

export { surfaceColors };
export default Surface;
